import proxy from "config/api";
import { errorMessageText, returnUrl } from "constants/other";

export const getMyOffers = async (token, filters, signal) => {
  let url =
    proxy.job +
    `employer/job-offers/?page=${filters.page}&page_size=${filters.pageSize}&archived=${filters.archived}`;
  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "GET", headers, signal });
  if (filters.archived === null) {
    return window.location.replace(`${returnUrl()}/error`);
  } else if (response.status === 200) {
    return await response.json();
  } else {
    throw response.status;
  }
};

export const getOfferPeople = async (token, offerId, filters, signal) => {
  const wasReadQuery = filters.was_read ? `&was_read=${filters.was_read}` : "";

  const pageQuery = `/?page=${filters.page}&page_size=${filters.pageSize}${wasReadQuery}`;

  const url = `${proxy.job}employer/application_list/${offerId}${pageQuery}`;
  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "GET", headers, signal });
  if (response.status === 200) {
    return await response.json();
  } else {
    throw new Error(await errorMessageText(response));
  }
};

export const setReadStatus = async (token, offerPersonId) => {
  let url =
    proxy.job + "employer/application_list/mark-as-read/" + offerPersonId + "/";
  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "PATCH", headers });
  if (response.status === 200) {
    return true;
  } else {
    throw new Error(await errorMessageText(response));
  }
};

export const setUnreadStatus = async (token, offerPersonId) => {
  let url =
    proxy.job +
    "employer/application_list/mark-as-unread/" +
    offerPersonId +
    "/";
  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "PATCH", headers });
  if (response.status === 200) {
    return true;
  } else {
    throw new Error(await errorMessageText(response));
  }
};

export const getZipUrl = async (token, offerId) => {
  let url = proxy.job + `employer/application_list/zip/${offerId}/`;

  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "GET", headers });
  if (response.status === 200) {
    return await response.json();
  } else {
    throw new Error(await errorMessageText(response));
  }
};

export const deleteOffer = async (token, offerId, signal) => {
  let url = proxy.job + `job-offer/${offerId}/`;

  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "DELETE", headers, signal });
  if (response.status === 200) {
    return response.json();
  } else {
    throw new Error(await errorMessageText(response));
  }
};

export const changeStateOfOffer = async (token, state, offerId) => {
  let url = `${proxy.job}job-offer/${offerId}/${state}/`;
  const headers = {
    Authorization: "token " + token,
    "Content-Type": "application/json",
  };

  const response = await fetch(url, { method: "PATCH", headers });

  if (response.status === 200) {
    return response.json();
  } else {
    throw new Error(await errorMessageText(response));
  }
};
